module.exports = __webpack_public_path__ + "guanao-pc/static/media/xiequan-mobile.886659e9.jpg";